module.exports = "/assets/c91372fdc2138f9fe4144ad7011d9f97.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/UU.png
// module id = 3023
// module chunks = 0